import App from "../index";
import anime, { AnimeInstance } from "animejs";
import { getEl, getEls } from "../helpers";
import { ScrollDirection } from "../classes/scroll-manager";

/**
 * Finds all elements on the page with the .anim-image class and adds an animation to them.
 * If they also have the .autoplay class then they perform the animation once they are scrolled
 * and visible on the screen.
 * If not, they have a custom event listener attached called "play". If you dispatch an event to
 * that then they will start their animation:
 *
 *  element.dispatchEvent("play");
 *
 */
export default class AnimatedHeadings
{
	static TRIGGER_ANIMATION_AT = 0.85; //How far down the page to trigger the animation expressed as a ratio of window height. 0 = top of the page, 1 = bottom of the page.

	//private app: App;

	// private headings: {
	// 	el: Element,
	// 	anim: AnimeInstance,
	// }[] = [];

	constructor(app: App) {

		let els = getEls('.anim-heading');
		for (let i = 0; i < els.length; i++)
		{
			const isAutoplay = els[i].classList.contains('autoplay');
			const animation:AnimeInstance = anime({
				targets: els[i].querySelectorAll('.heading-piece'),
				autoplay: false,
				translateY: ['105%', '0%'],
				delay: anime.stagger(40),
				easing: 'easeOutQuint',
				duration: 1000,
			});

			if (isAutoplay) {
				app.scroller.addVisibilityTrigger(els[i], (dir) => {
					if (animation && !animation.completed) animation.play();
				}, AnimatedHeadings.TRIGGER_ANIMATION_AT);
			} else {
				els[i].addEventListener("play", (e) => {
					if (animation && !animation.completed) animation.play();
				}, {once: true});
			}
		}
	}
}
